import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import cantu from "../../Assets/Projects/cantu.png"
import haier from "../../Assets/Projects/haier.png"
import tenax  from "../../Assets/Projects/tenax.png"
import optimo  from "../../Assets/Projects/optimo.png"
import inoptim from "../../Assets/Projects/inoptim.png"
import github from "../../Assets/Projects/github.png"
import rayzo from "../../Assets/Projects/rayzo.png"
import testEgg from "../../Assets/Projects/testEgg.png"
import hera from "../../Assets/Projects/hera.png"
import sekurest from "../../Assets/Projects/sekurest.jpeg"
import gellify from "../../Assets/Projects/gellify.jpeg"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="textColor">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cantu}
              isBlog={false}
              title="Pallacanestro Cantù"
              description="Complete graphical redesign of the main site of Pallacanestro Cantù basket, one of the main teams in Serie A of italian basketball."
              link="https://pallacanestrocantu.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={haier}
              isBlog={false}
              title="Haier Spares EU"
              description="Work on the front-end section of the offial e-commerce of Haier domestic appliances in Europe."
              link="https://www.haierspares.eu/it/home"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tenax}
              isBlog={false}
              title="Tenax Portal"
              description="Worked on a completely new, wordpress based portal, for internal usage at Tenax SPA, the project is still evolving and used daily at the company with great results."
              link="https://www.tenax.net/it/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={optimo}
              isBlog={false}
              title="Optimo IOT"
              description="Exprience with an AWS cloud based software developed at Optimo IOT, used to track data from machines with a proprietary raspberry based gateway, i worked on the frontend of the configurator using vue.js."
              link="https://www.optimoiot.it/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={inoptim}
              isBlog={false}
              title="Inopera"
              description="Worked on the back-end of a c# based MES used by 250 companies, using C# .NET and asp.NET and working with databases."
              link="https://github.com/simone-perego/Vue.js-Spacex-Launches"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={github}
              isBlog={false}
              title="Spacex Launches"
              description="Personal Project, a site to show Spacex Launches with details of every ship, developed with vue.js."
              link="https://github.com/simone-perego/Vue.js-Spacex-Launches"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={github}
              isBlog={false}
              title="Bitcoin Wallet"
              description="Personal Poject, a site to convert criptocurrency amount in any currency, developed with React.js"
              link="https://github.com/simone-perego/React-Stella-Bitcoin-Wallet"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={rayzo}
                isBlog={false}
                title="Rayzo"
                description="Startup project: Rayzo is a platform designed to automate and simulate LinkedIn interactions to streamline and accelerate the hiring process."
                link="https://rayzo.io/it/product-price/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={testEgg}
                isBlog={false}
                title="Testegg"
                description="Startup project: Testegg provides a wide range of assessments across multiple subjects to evaluate individual or team skills."
                link="https://www.linkedin.com/company/testegg-venturebox/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={gellify}
                isBlog={false}
                title="Margherita"
                description="Internal project developed for client Margherita."
                link="https://github.com/simone-perego/React-Stella-Bitcoin-Wallet"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={hera}
                isBlog={false}
                title="Hera"
                description="Internal project: AI-powered chatbot developed for Hera."
                link="https://github.com/simone-perego/React-Stella-Bitcoin-Wallet"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={gellify}
                isBlog={false}
                title="FPZ"
                description="Internal project: AI-based chatbot solution developed for FPZ."
                link="https://github.com/simone-perego/React-Stella-Bitcoin-Wallet"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={gellify}
                isBlog={false}
                title="Cesare"
                description="Internal AI chatbot project developed for GELLIFY."
                link="https://github.com/simone-perego/React-Stella-Bitcoin-Wallet"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={gellify}
                isBlog={false}
                title="VivaTicket"
                description="Worked as an external consultant on the VivaTicket platform."
                link="https://github.com/simone-perego/React-Stella-Bitcoin-Wallet"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
                imgPath={sekurest}
                isBlog={false}
                title="Sekurest"
                description="Worked as an external consultant on the Sekurest project."
                link="https://github.com/simone-perego/React-Stella-Bitcoin-Wallet"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
